import LatestNewsContainer from "./LatestNewsContainer";
export default LatestNewsContainer;
